<template>
  <div class="help-tooltip">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          small
          color="primary"
          class="question-icon"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>
      <span>Faça o upgrade do seu plano para liberar.</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PlanUpgradeInfo',
};
</script>

<style scoped>
.help-tooltip {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1000;
}

.question-icon {
  cursor: pointer;
  font-size: 16px; /* pequeno */
}
</style>
